import React from 'react'

import styles from './Input.module.css'

const TextArea = ({
  value,
  onChange,
  rows,
  className,
  placeholder,
  label,
  disabled,
}) => {
  return (
    <div
      className={`${styles.container} ${className || styles.defaultContainer}`}
    >
      <textarea
        type="text"
        className={styles.input}
        rows={rows}
        value={value || ''}
        placeholder={placeholder || label}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        required
      />
      <label>{label || placeholder}</label>
    </div>
  )
}

export default TextArea
